import { render, staticRenderFns } from "./urllink.vue?vue&type=template&id=64aff68e&scoped=true"
import script from "./urllink.vue?vue&type=script&lang=js"
export * from "./urllink.vue?vue&type=script&lang=js"
import style0 from "./urllink.vue?vue&type=style&index=0&id=64aff68e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aff68e",
  null
  
)

export default component.exports